import React from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./miniStat.module.scss";
import { AutoGraph, QueryStats, ShowChart } from "@mui/icons-material";

const MiniStat = ({ miniStatDatas }) => {
  return (
    // <Row className={styles.tileRow}>
    //   {miniStatDatas.map((item) => (
    //     <Col className={styles.tileCol} key={item.id}>
    //       <div
    //         className={styles.iconContainer}
    //         style={{
    //           backgroundColor: item.bg,
    //           color: item.color,
    //         }}
    //       >
    //         {item.icon}
    //       </div>
    //       <div className={styles.infoContainer}>
    //         <div className={styles.infoTitle}>{item.infoTitle}</div>
    //         <div className={styles.info}>{item.info}</div>
    //       </div>
    //     </Col>
    //   ))}
    // </Row>
    <Row className={styles.tileRow}>
      {miniStatDatas.map((item) => (
        <Col
          xs={12}
          sm={6}
          md={4}
          lg={6}
          className={styles.tileCol}
          key={item.id}
        >
          <div
            className={styles.iconContainer}
            style={{
              backgroundColor: item.bg,
              color: item.color,
            }}
          >
            {item.icon}
          </div>
          <div className={styles.infoContainer}>
            <div className={styles.infoTitle}>{item.infoTitle}</div>
            <div className={styles.info}>{item.info}</div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default MiniStat;
